import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { CompanyStatus } from '../../models/business/CompanyStatus'
import { COMPANY_STATUSES_URL } from '../../utils/urls'

const fetchCompanyStatuses = (params: TableParams) =>
  SBAPI.FetchPaginated<CompanyStatus[]>(COMPANY_STATUSES_URL, params)

const fetchCompanyStatusById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<CompanyStatus>(`${COMPANY_STATUSES_URL}/${id}`, params)

const createCompanyStatus = (companyStatus: CompanyStatus) =>
  SBAPI.Post(COMPANY_STATUSES_URL, companyStatus)

const updateCompanyStatus = (companyStatus: CompanyStatus) =>
  SBAPI.Put(`${COMPANY_STATUSES_URL}/${companyStatus.id}`, companyStatus)

const deleteCompanyStatus = (companyStatus: CompanyStatus) =>
  SBAPI.Delete(`${COMPANY_STATUSES_URL}/${companyStatus.id}`)

export {
  createCompanyStatus,
  deleteCompanyStatus,
  fetchCompanyStatusById,
  fetchCompanyStatuses,
  updateCompanyStatus,
}
